/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-warning-comments */

import { LoadingContainer } from 'components/loadingContainer'
import { PlaceholderContainer } from 'components/placeholder'
import { SeatSelector } from 'components/seatSelector'
import { ShowEventSelector } from 'components/showEventSelector'
import { Container, PageTitle, ShowTitle, TitleBox } from 'components/ticket/ticket.style'
import { useEventsUser } from 'hooks/user/useEvents'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { EventDetails } from 'types/Event'
import { isSellingWindowValid } from 'utils/sellingWindow'

interface Props {
    currentEvent: EventDetails
}

export const TicketBuying = ({ currentEvent }: Props) => {
    const [bookingTime, setBookingTime] = useState(599)
    const { data: events, isLoading, error } = useEventsUser()
    const navigate = useNavigate()

    const navigateToBasket = (selectedSeats: string[]) => {
        navigate(`/jegyek/kosar/${currentEvent.event_id}?seats=${selectedSeats.join(',')}`)
    }

    useEffect(() => {
        if (!isSellingWindowValid(currentEvent.selling_start_date, currentEvent.selling_end_date)) {
            navigate(`/musor/${currentEvent.show_id}`, { replace: true })
        }
    }, [currentEvent.selling_start_date, currentEvent.selling_end_date, currentEvent.show_id, navigate])

    // TODO: booking time foglalás idő
    // const formattedTime = `${Math.floor(bookingTime / 60)}:${(bookingTime % 60).toString().padStart(2, '0')}`

    return (
        <Container>
            <PageTitle>Jegyvásárlás</PageTitle>
            <TitleBox>
                <ShowTitle>{currentEvent.show.name}</ShowTitle>
            </TitleBox>
            <LoadingContainer isLoading={isLoading} error={error}>
                {events && (
                    <ShowEventSelector
                        currentEvent={currentEvent}
                        events={events}
                        title="Kiválasztott előadás"
                        redirectUrl="/jegyek/vasarlas"
                    />
                )}
            </LoadingContainer>
            {currentEvent.location.auditorium ? (
                <SeatSelector currentEvent={currentEvent} actionLabel="Vásárlás" actionHandler={navigateToBasket} />
            ) : (
                <PlaceholderContainer>
                    <p>A jegyvásárlás jelenleg nem elérhető ehhez az eseményhez.</p>
                </PlaceholderContainer>
            )}
        </Container>
    )
}
